class ArticlesTabs {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.categoryBtns = this.root.querySelectorAll(
            '[data-articles-tabs-category]'
        );
        this.lists = this.root.querySelectorAll('[data-articles-tabs-list]');

        return true;
    }

    init() {
        if (!this.categoryBtns.length || !this.lists.length) return;
        this.onCategory = this.onCategoryClick.bind(this);
        this.categoryBtns.forEach(btn => {
            btn.addEventListener('click', this.onCategory);
        });
    }

    onCategoryClick(event) {
        const { currentTarget } = event;
        const id = currentTarget.getAttribute('data-articles-tabs-category');

        this.categoryBtns.forEach(btn => btn.classList.remove('bg-white'));
        currentTarget.classList.add('bg-white');

        this.lists.forEach(list => {
            const listId = list.getAttribute('data-articles-tabs-list');
            list.hidden = listId !== id;
        });
    }
}

const initArticlesTabs = () => {
    const sections = document.querySelectorAll('[data-articles-tabs]');
    if (!sections.length) return;

    sections.forEach(el => new ArticlesTabs(el));
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticlesTabs);
} else {
    initArticlesTabs();
}
